import AddIcon from '@mui/icons-material/Add';
import { Box, useTheme } from "@mui/material";
import MpAddOrder from "../../../../../components/global/ModalsProgression/MpAddOrder/MpAddOrder";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import Text from "../../../../../components/theme/text/Text";
import { tokens } from "../../../../../theme";

import BallotIcon from '@mui/icons-material/Ballot';
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import OrdersCard from "../../../../../components/global/cards/orders/OrdersCard";
import { ORDER_FILTER_KEYS } from '../../../../../components/global/DataGrid/Filter';
import MCreateBatchFromOrders from '../../../../../components/global/Modals/MCreateBatchFromOrders';
import SpPickingJobPickingList from '../../../../../components/global/Sidepanels/SpPickingJobPickingList/SpPickingJobPickingList';
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import DropdownButton from '../../../../../components/theme/buttons/DropdownButton';
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShDataGridSelectedActions from '../../../../../components/theme/datagrid2/ShDataGridSelectedActions';
import ShLabel from "../../../../../components/theme/label/ShLabel";
import SHQuickAction from '../../../../../components/theme/Modal/SHQuickAction';
import ShCopyButton from '../../../../../components/theme/ShCopy';
import SidepanelLoader from '../../../../../components/theme/sidepanel2/SidepanelLoader';
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import { useBulkUpdateOrdersMutation, useGetOrdersQuery } from "../../../../../newapi/order/ordersSlice";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { getOrderStateData } from "../../../../../utils/labelColorText";
import { UserPrivileges } from '../../../../../utils/permissions';
import { general_states } from '../../../../../utils/staticEnums';
import MCreateBatch from '../../../../../components/global/Modals/MCreateBatch/MCreateBatch';
import MConfirmation from '../../../../../components/global/Modals/MConfirmation';
import MSnoozeOrder from '../../../../../components/global/Modals/MSnoozeOrder';
import { showToastMessageRequestError, showToastMessageUpdateRequest } from '../../../../../utils/toasts';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import BusinessIcon from '@mui/icons-material/Business';
const SpOrderDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));

const styles = (colors) => {
   return {
        footer: {
            justifyContent:'space-between !important',
        }
    }
}

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    return props.hasCreatePermission ?
        <ButtonGroup version={2}>
            <Shbutton 
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                onClick={() => props.handleOpen(true)}
                endIcon={<AddIcon/>}
                variant="contained"
            >
                {t('new_order')}
            </Shbutton>
        </ButtonGroup> : <></>
}

const OutBoundOrders = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);

    const gridOptions = {
        export:true,
        disableCustomActionsOnPhone: true,
        isSidepanel: true,
        filter: [
            ORDER_FILTER_KEYS.PROCESS_STATE,
            ORDER_FILTER_KEYS.STREAM,
            ORDER_FILTER_KEYS.SHIPPER,
            ORDER_FILTER_KEYS.PRODUCT,
            ...(isFulfilment ? [ORDER_FILTER_KEYS.RELATION, ORDER_FILTER_KEYS.EXCLUDE_RELATION] : []),
            ORDER_FILTER_KEYS.PAST_ORDERS,
            ORDER_FILTER_KEYS.B2B_ORDERS,
            ORDER_FILTER_KEYS.COUNTRY,
        ],
    };

    // const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [pickingJobIsExtended, setPickingJobIsExtended] = useState(false);
    const [spPickingJobLoading, setSpPickingJobLoading] = useState();

    const [createdPickingJobId, setCreatedPickingJobID] = useState(0);

    const hasModifyPrivilege = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.PICKINGJOB_MANAGE])
    );
    const [config,setConfig] = useState({...props.tableConfig, untillToday: true});

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.OUTBOUND_MANAGE])
    );
    
    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleOpen = () => {
        setAddModalOpen(true);
    }

    const [defaultTab, setDefaultTab] = useState(null);
    const handleClose = (response) => {
        setAddModalOpen(false);
        const newOrderState = response?.data?.state ?? response?.state;
        const newOrderId = response?.data?.id ?? response?.id;
        if (newOrderState === general_states.ACTION_REQUIRED_CUSTOMER && newOrderId) {
            if (!spLoading) setSpLoading(true);
            setOrderId(newOrderId);
            orderIdRef.current = newOrderId;
            setDefaultTab(2);
            setIsExtended(true);
        }
    };



    const [createBatchModalOpen,setCreateBatchModalOpen] = useState(false);
    const createBatchModal = {
        open: createBatchModalOpen,
        setOpen: setCreateBatchModalOpen,
    }

    const createBatchOpen = () => {
        setCreateBatchModalOpen(true);
    }

    const createBatchClose = () => {
        setCreateBatchModalOpen(false);
    }

    const [snoozeOrderModalOpen,setSnoozeOrderModalOpen] = useState(false);
    const snoozeOrderModal = {
        open: snoozeOrderModalOpen,
        setOpen: setSnoozeOrderModalOpen,
    }

    const [pauseOrderModalOpen,setPauseOrderModalOpen] = useState(false);
    const pauseOrderModal = {
        open: pauseOrderModalOpen,
        setOpen: setPauseOrderModalOpen,
    }

    const [bulkUpdateOrders, { isLoading: updateLoading }] = useBulkUpdateOrdersMutation();

    const handleSnoozeOrders = async() => {
        if (selectedItems.length === 0) return;

        if(updateLoading) return;

        try {
            const response = await bulkUpdateOrders({
                orderIds: selectedItems,
                state: general_states.SNOOZE,
                oldState: general_states.OPEN
            }).unwrap();

            setSelectedItems([]); // Clear selection after successful update
            snoozeOrderModal.setOpen(false);
            showToastMessageUpdateRequest(t, response);
        } catch (error) {
            console.error('Failed to snooze orders:', error);
            showToastMessageRequestError(t("update_failed"), t, error);
        }
    }

    const handlePauseOrders = async(date_planned) => {
        if (selectedItems.length === 0) return;

        if(updateLoading) return;

        try {
            await bulkUpdateOrders({
                orderIds: selectedItems,
                state: general_states.OPEN,
                date_planned: date_planned
            }).unwrap();

            setSelectedItems([]); // Clear selection after successful update
            pauseOrderModal.setOpen(false);
            showToastMessageUpdateRequest(t, { success: true, message: t('orders_paused_successfully') });
        } catch (error) {
            console.error('Failed to pause orders:', error);
            showToastMessageUpdateRequest(t, { success: false, error: error.error });
        }
    }

    useEffect(() => {
        if(props.tableConfig){
            setConfig({...props.tableConfig, untillToday: true});
        }
    },[props.tableConfig])

    const [selectedItems, setSelectedItems] = useState([]);
    const onSelected = (locSelectedItems) => {
        setSelectedItems(locSelectedItems);
    };

    const handleCardSelection = (id) => {
        setSelectedItems((prevSelectedIds) => {
            if (prevSelectedIds.includes(id)) {
                // Deselect the card if it's already selected
                return prevSelectedIds.filter((selectedId) => selectedId !== id);
            } else {
                // Select the card if it's not selected
                return [...prevSelectedIds, id];
            }
        });
    };
    
    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions 
                    handleOpen={handleOpen} 
                    hasCreatePermission={hasCreatePermission}
                />,
            styles:styles(colors)
        });

        return () => {
            
        }
    },[]);

    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrderDetails = (params) => {
        if (!params) return;
    
        const neworderId = parseInt(params.row.id);
        // Only update state if the orderId has actually changed
        if (orderIdRef.current !== neworderId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setOrderId(neworderId);
            orderIdRef.current = neworderId; // Update the ref to the new value
        }
        setDefaultTab(null);
        setIsExtended(true);
    };
    

    const columns = [
        {
            field: "barcode",
            headerName: t('order'),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Box
                            sx={{
                                minWidth:"100%",
                                height:"100%",
                                display:"flex",
                                alignItems:"center",
                                position:"relative",
                                whiteSpace:"nowrap",
                                wordBreak:"keep-all",
                                textOverflow:"ellipsis",
                                overflow:"hidden",
                                gap:2,

                            }}
                        >
                            <Text noBreak>{params.row.barcode}</Text>
                            {params.row.remark &&
                                <SHQuickAction
                                    disableScrollLock={true}
                                    component={
                                        <Box
                                            sx={{
                                                px:1.5,
                                                display:"flex",
                                                flexDirection:"column"
                                            }}
                                        >
                                            <Text light>{t("remark")}</Text>
                                            <Text>{params.row.remark}</Text>
                                        </Box>
                                    }
                                >
                                    {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                        <Box
                                            aria-owns={anchorEl ? 'simple-popover' : undefined}
                                            aria-haspopup={false}
                                            onMouseEnter={onMouseEnter}
                                            onMouseLeave={onMouseLeave}
                                            onTouchStart={onTouchStart}
                                            sx={{
                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                                height:32,
                                                width:32,
                                                color: colors.txt['secondary'],
                                                display:'flex',
                                                alignItems:'center',
                                                justifyContent:'center',
                                                borderRadius:4,
                                            }}
                                        >
                                            <CommentOutlinedIcon fontSize='small'/>
                                        </Box>
                                    )}
                                </SHQuickAction>
                            }
                            {params.row.isB2B &&
                                <SHQuickAction
                                    disableScrollLock={true}
                                    component={
                                        <Box
                                            sx={{
                                                px:1.5,
                                                display:"flex",
                                                flexDirection:"column"
                                            }}
                                        >
                                            <Text light>{t("b2b")}</Text>
                                        </Box>
                                    }
                                >
                                    {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                        <Box
                                            aria-owns={anchorEl ? 'simple-popover' : undefined}
                                            aria-haspopup={false}
                                            onMouseEnter={onMouseEnter}
                                            onMouseLeave={onMouseLeave}
                                            onTouchStart={onTouchStart}
                                            sx={{
                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                                height:32,
                                                width:32,
                                                color: colors.txt['secondary'],
                                                display:'flex',
                                                alignItems:'center',
                                                justifyContent:'center',
                                                borderRadius:4,
                                            }}
                                        >
                                            <BusinessIcon fontSize='small'/>
                                        </Box>
                                    )}
                                </SHQuickAction>
                            }
                        </Box>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.barcode}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {field: "deliveryName", headerName: t("name"),flex:1, 
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.deliveryName
            }
        },
        {field: "webshopreference", 
            headerName: t("webshopreference"),
            flex:2,
            filter: ORDER_FILTER_KEYS.RELATION,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (<Text>{`${params.row.relation?.name} - ${params.row.webshopreference} (${params.row.deliveryCountry ? params.row.deliveryCountry.toUpperCase() : ""})`}</Text>)
            }
        },
        {
            field: "date_planned", 
            headerName: t("date_planned_shipment"),
            flex:1,
            shFilter: {
                type: "date"
            },
            filter: ORDER_FILTER_KEYS.PAST_ORDERS,
            renderCell: (params) => {

                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                let labelcolor = theme.palette.mode === "dark" ? "greyLight" : "grey";
                let planned = new Date(params.row.date_planned);
                let sent = params.row.date_sent ? new Date(params.row.date_sent) : null;
                let latestHandoverDateTime = params.row.latestHandoverDateTime ? new Date(params.row.latestHandoverDateTime) : null;

                if(sent) {
                    // when sent is filled and is equal to planned: green
                    if(sent.getTime() === planned.getTime()) {
                        labelcolor = "green";
                    }
                    // when sent is filled but later than planned: orange
                    else if(sent.getTime() > planned.getTime()) {
                        labelcolor = "orange";
                    }
                }
                else {
                    // When sent is not filled and planned >= now: blue
                    if(planned.setHours(0,0,0,0) >= new Date().setHours(0,0,0,0)) {
                        labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
                    } else if(latestHandoverDateTime && (new Date().setHours(0,0,0,0) < latestHandoverDateTime)) {
                        labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
                    // When sent is not filled and planned < now: red
                    } else if(planned.setHours(0,0,0,0) < new Date().setHours(0,0,0,0)) {
                        labelcolor = "red";
                    }
                }
              
                return (
                    <SHQuickAction
                        disableScrollLock={true}
                        component={ params.row.latestHandoverDateTime !== null ?
                            <Box
                                sx={{
                                    px:1.5,
                                    display:"flex",
                                    flexDirection:"column"
                                }}
                            >
                                <Text light>{t("handover_date")}</Text>
                                <Text>
                                    { new Date(params.row.latestHandoverDateTime).toLocaleDateString(i18n.language)}&nbsp;
                                    <b>
                                    {new Date(params.row.latestHandoverDateTime).toLocaleTimeString(i18n.language, {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}
                                    </b>
                                </Text>
                            </Box>
                            : 
                            null
                        }
                    >
                        {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                            <Box
                                aria-owns={anchorEl ? 'simple-popover' : undefined}
                                aria-haspopup={false}
                                onMouseEnter={params.row.latestHandoverDateTime !== null ? onMouseEnter : null}
                                onMouseLeave={params.row.latestHandoverDateTime !== null ? onMouseLeave : null}
                                onTouchStart={params.row.latestHandoverDateTime !== null ? onTouchStart : null}
                                sx={{
                                    width:1,
                                }}
                            >
                                <ShLabel clickable size={32} fitted variant={labelcolor} palette="normal">
                                    {!sent && planned.toLocaleDateString(i18n.language)}
                                    {sent && sent.toLocaleDateString(i18n.language)}
                                </ShLabel>
                            </Box>
                        )}
                    </SHQuickAction>
                );
            }
        },
        {field: "orderlinesCount", headerName: t("orderlines_count"),flex:1,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.row.amountOfLines
        }},
        {
            field: "stream", 
            headerName: t("stream"),
            flex:1,
            filter: ORDER_FILTER_KEYS.STREAM,

            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.stream?.shortName
            }
        },
        {
            field: "shipper", 
            headerName: t("shipper_name"),
            flex:2,

            filter: ORDER_FILTER_KEYS.SHIPPER,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return `${params.row.shipper?.name ?? ""} - ${params.row.shipperprofile?.name ?? ""}`
            }
        },
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            filter: ORDER_FILTER_KEYS.PROCESS_STATE,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }
                
                const { labelcolor, labeltext } = getOrderStateData(params.row.state, theme, false, params.row.snoozeWhenAvailable);
              
                return (
                    <SHQuickAction
                    disableScrollLock={true}
                    component={ params.row.skipReason !== null ?
                        <Box
                            sx={{
                                px:1.5,
                                display:"flex",
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("reason_to_skip")}</Text>
                            <Text>
                                {params.row.skipReason}
                            </Text>
                        </Box>
                        : 
                        null
                    }
                >
                    {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                        <Box
                            aria-owns={anchorEl ? 'simple-popover' : undefined}
                            aria-haspopup={false}
                            onMouseEnter={params.row.skipReason !== null ? onMouseEnter : null}
                            onMouseLeave={params.row.skipReason !== null ? onMouseLeave : null}
                            onTouchStart={params.row.skipReason !== null ? onTouchStart : null}
                            sx={{
                                width:1,
                            }}
                        >
                             <ShLabel clickable size={32} palette="normal" variant={labelcolor}>
                                {t(labeltext)}
                            </ShLabel>
                        </Box>
                    )}
                </SHQuickAction>

                    // <ShLabel size={32} palette="normal" variant={labelcolor}>
                    //   {t(labeltext)}
                    // </ShLabel>
                  );
              }
        },
        {
            field: "createdAt", 
            headerName: t("date_created"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const date = new Date(params.row.createdAt);
                const dateStr = date.toLocaleDateString(i18n.language, { dateStyle: 'short' });
                const timeStr = date.toLocaleTimeString(i18n.language, { timeStyle: 'short' });

                return (
                    <span>
                        {dateStr}{' '}<Text light>{timeStr}</Text>
                    </span>
                );
              }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <OrdersCard
                        selectable={params.row.state === general_states.OPEN}
                        select={handleCardSelection} 
                        selected={selectedItems.includes(params.row.id)} 
                        onClick={() => getOrderDetails(params)} 
                        skeleton={params.row.skeleton ?? false} 
                        {...params.row}  
                    />
                )
            }
        }
    ];
    
    const defaultSort = useMemo(
        () => ({ field: columns[8].field, type: "ASC" }),
        [columns]
    );
    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            <ShDataGrid2 key={theme.palette.mode}
                pollingInterval={true}
                content={useGetOrdersQuery}
                config={config}
                title={t('order_can_be_picked')}
                gridActions={<GridActions handleOpen={handleOpen} hasCreatePermission={hasCreatePermission}></GridActions>} 
                gridOptions={gridOptions} 
                sortModel={defaultSort}
                columns={columns}
                onRowClick={getOrderDetails}
                selectable
                setSelected={onSelected}
                keepSelectedAlive
                keepNonExistentRowsSelected
                selectedItems={selectedItems}
                selectedActions={
                    <ShDataGridSelectedActions selectedItems={selectedItems}>
                        {/* <DropdownButton onClick={handlePrintAction} icon={<PrintIcon/>} text={t("print")}/> */}
                        {hasModifyPrivilege && (
                            <DropdownButton 
                                onClick={createBatchOpen} 
                                icon={<BallotIcon/>} 
                                text={t("create_batch_from_orders")}
                            />
                        )}
                        {hasModifyPrivilege && (
                            <DropdownButton
                                onClick={() => snoozeOrderModal.setOpen(true)}
                                icon={<BallotIcon/>}
                                text={t("snooze_orders")}
                            />
                        )}
                        {hasModifyPrivilege && (
                            <DropdownButton
                                onClick={() => pauseOrderModal.setOpen(true)}
                                icon={<BallotIcon/>}
                                text={t("pause_orders")}
                            />
                        )}
                    </ShDataGridSelectedActions>
                }
                isRowSelectable={(row) => {
                    if(!hasModifyPrivilege || row.state !== general_states.OPEN) {
                        return false;
                    }
                    return true;
                }}
            />
            {spLoading &&
                <SpOrderDetails
                    defaultTab={defaultTab}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    orderId={orderId}
                    relation={false}
                    canReserveOrderLines={false}
                /> 
            }

            {spPickingJobLoading && 
                <SpPickingJobPickingList
                    isExtended={pickingJobIsExtended}
                    setIsExtended={setPickingJobIsExtended}
                    pickingJobListId={createdPickingJobId}
                    
                    // data={pickingJobData}
                /> 
            }
            <MCreateBatchFromOrders 
                onOpen={() => createBatchModal.setOpen(true)} 
                onClose={() => createBatchModal.setOpen(false)} 
                open={createBatchModal.open} 
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                handleClose={createBatchClose} 
            />

            <MConfirmation
                open={snoozeOrderModal.open}
                handleClose={() => setSnoozeOrderModalOpen(false)}
                title={t("snooze_orders")}
                content={t("snooze_orders_text")}
                confirm={() => handleSnoozeOrders()}
            />

            <MSnoozeOrder
                open={pauseOrderModal.open}
                handleClose={() => setPauseOrderModalOpen(false)}
                confirm={(date_planned) => handlePauseOrders(date_planned)}
            />

            <MpAddOrder 
                onOpen={() => addModal.setOpen(true)} 
                onClose={() => addModal.setOpen(false)} 
                open={addModal.open} 
                handleClose={handleClose} 
            />
        </Box>
    );
}

export default OutBoundOrders;